"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _MarginDepositForm = _interopRequireDefault(require("./MarginDepositForm"));
var _modalActions = require("../../../../redux/actions/modalActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var product = state.apexCore.product,
    user = state.user,
    modal = state.modal;
  var modalProps = modal[_modalActions.MODAL_TYPES.MARGIN_DEPOSIT].modalProps || {};
  var selectedProduct;
  if (modalProps.productId) {
    selectedProduct = product.products.find(function (product) {
      return product.ProductId === modalProps.productId;
    });
  } else {
    selectedProduct = product.products[0];
  }
  return {
    products: product.products,
    selectedProductId: selectedProduct.ProductId,
    accounts: user.accounts,
    accountTo: user.accounts[0].AccountId
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    closeModal: function closeModal() {
      return dispatch((0, _modalActions.closeModal)(_modalActions.MODAL_TYPES.MARGIN_DEPOSIT));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_MarginDepositForm["default"]);